export const environment = {
  production: false,
  TENANT_ID:
    'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
  CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
  REDIRECT_URL: 'https://sit.lios.toyota.com',
  log_level: 'debug',
  ADMIN_DS_URI: 'https://api.sit.lios.toyota.com/admin/graphql',
  APM_DS_URI: 'https://api.sit.lios.toyota.com/apm/graphql',
  BILLING_DS_URI: 'https://api.sit.lios.toyota.com/billing/graphql',
  OPERATION_DS_URI : "https://api.sit.lios.toyota.com/operations/graphql",
  MAINTENANCE_DS_URI : "https://api.sit.lios.toyota.com/maintenance/graphql",
  manifest: {
    admin: 'https://admin.sit.lios.toyota.com/remoteEntry.js',
    apm: 'https://apm.sit.lios.toyota.com/remoteEntry.js',
    bm: 'https://bm.sit.lios.toyota.com/remoteEntry.js',
    lcm: 'https://lcm.sit.lios.toyota.com/remoteEntry.js',
    cm: 'https://cm.sit.lios.toyota.com/remoteEntry.js',
    drc: 'https://drc.sit.lios.toyota.com/remoteEntry.js',
    gc: 'https://generalcosts.sit.lios.toyota.com/remoteEntry.js',
    ec: 'https://ec.sit.lios.toyota.com/remoteEntry.js',
    lpi: 'https://lpi.sit.lios.toyota.com/remoteEntry.js',
    bs: 'https://billingsummary.sit.lios.toyota.com/remoteEntry.js',
    sur: 'https://sur.sit.lios.toyota.com/remoteEntry.js',
    maintenance: 'https://maintenance.sit.lios.toyota.com/remoteEntry.js',
    mshell: 'https://mshell.sit.lios.toyota.com/remoteEntry.js',
    bshell: 'https://bshell.sit.lios.toyota.com/remoteEntry.js',
  },
  TASK_MANAGER: 'https://liosapps.qa.toyota.com/board',
  AET: 'https://ts.stage.portal.toyotasupplier.com/aet',
  ALARMS: 'https://liosapps.qa.toyota.com/alarms',
  CO2: 'https://liosapps.qa.toyota.com/co2',
  COST_PLANNING: 'https://liosapps.qa.toyota.com/costplanning',
  EBOI: 'https://liosapps.qa.toyota.com/eboi',
  EXPORT: 'https://liosapps.qa.toyota.com/export',
  GROUPI: 'https://liosapps.qa.toyota.com/groupi'
};
